export default __webpack_public_path__ + "static/media/digital-empire-big-11@2x.7851dc94.png";